export const environment = {
  production: false,
  baseUrl: 'http://localhost:4200/Images',

}